import { render, staticRenderFns } from "./AdvancedCollateForm.vue?vue&type=template&id=7817dea6&"
import script from "./AdvancedCollateForm.vue?vue&type=script&lang=js&"
export * from "./AdvancedCollateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports